import Timer from './timer.js';

const DOMElements = {
	gameTimerDisplay: '#game-timer-display',
};

const gameTimerDisplay = document.querySelector(DOMElements.gameTimerDisplay);

const displayGameOverMessage = () => {
	if (gameTimerDisplay) {
		gameTimerDisplay.innerHTML = 'Game over...';
	}
};

const formTime = (el) => {
	const formattedTime = el.toLocaleString('de-DE', {
		minimumIntegerDigits: 2,
		useGrouping: false,
	});

	return formattedTime;
};

const CounterService = {
	grouptimerfunction: () => {
		const x = setInterval(function () {
			const distance = Timer.timeDistance();

			const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
			const minutes = Math.floor((distance % (60 * 60)) / 60);
			const seconds = Math.floor(distance % 60);

			if (gameTimerDisplay) {
				gameTimerDisplay.innerHTML =
					formTime(hours) + ':' + formTime(minutes) + ':' + formTime(seconds);
			}

			if (distance < 0) {
				clearInterval(x);
				displayGameOverMessage();
			}
		}, 1000);
	},
};

export default CounterService;
